export default "/images/closeIcon.png?ad65be494f6508a2a64cfe7e0659f735";